import { render, staticRenderFns } from "./TaskStoreListYuSouOrder.vue?vue&type=template&id=2461b6fa&"
import script from "./TaskStoreListYuSouOrder.vue?vue&type=script&lang=js&"
export * from "./TaskStoreListYuSouOrder.vue?vue&type=script&lang=js&"
import style0 from "./TaskStoreListYuSouOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports